import React from "react";
import { Pagination } from "@mui/material";

export default function PaginationComponent({ results, pageChanged }) {
  const [page, setPage] = React.useState(1);

  React.useEffect(() => {
    setPage(results.current_page);
  }, [results]);

  return (
    <Pagination
      page={page}
      count={results.last_page}
      // variant="outlined"
      // shape="rounded"
      onChange={pageChanged}
      color="primary" 
      sx={{
        display:'flex',
        justifyContent:'flex-end'
      }}
    />
  );
}
